import { useComputed } from "@preact/signals";
import Icon from "$store/components/ui/Icon.tsx";
import { useCart } from "apps/vtex/hooks/useCart.ts";
import { toAnalytics } from "site/sdk/ga4/transform/toAnalytics.ts";
import { sendEvent } from "site/sdk/analytics.tsx";

export default function Button() {
  const { cart } = useCart();
  const totalItems = cart.value?.items.length;

  const viewCartEvent = useComputed(() => {
    return toAnalytics({
      type: "view_cart",
      data: {
        items: cart.value?.items.map((item, index) => ({
          sku: item.id,
          inProductGroupWithID: item.productId,
          name: item.name,
          seller: item.seller,
          listPrice: parseFloat((item.listPrice / 100).toFixed(2)),
          price: parseFloat((item.price / 100).toFixed(2)),
          url: `${self?.location.host}${item.detailUrl}`,
          brand: item.additionalInfo.brandName ?? "",
          category: Object.values(item.productCategories).join(">") ?? "",
          extended: { index, quantity: item.quantity },
        })) ?? [],
        view: { id: "minicart", name: "Carrinho" },
      },
    });
  });

  return (
    <label
      class="pr-3 flex justify-self-end cursor-pointer"
      htmlFor="minicart-drawer"
      aria-label="Abrir o carrinho de compras"
      onClick={() => {
        sendEvent(viewCartEvent.value);
      }}
    >
      <div class="w-12 h-12 rounded-full bg-tw-base-50 flex justify-center items-center">
        <div class="indicator">
          <span class="indicator-item w-6 h-6 rounded-full bg-tw-primary-100 text-white text-sm leading-none font-maven font-semibold flex justify-center items-center -right-3">
            {totalItems ? totalItems > 9 ? "9+" : totalItems : 0}
          </span>

          <Icon
            id="Cart"
            class="text-tw-primary-100"
            width={25}
            height={25}
          />
        </div>
      </div>
    </label>
  );
}
